import { create } from 'zustand';

export interface RawTerrainData {
  gridSize: number;
  flatX: Float32Array;
  flatY: Float32Array;
  flatDem: Float32Array;
  flatChm: Float32Array;
  resolution: number;
}

export interface ComputedGeomorphicData {
  medoids: number[];
  shadowPrices: number[];
  classes: number[];
  flowAcc: number[];
  bal: number[];
  solar: number[];
  slope: number[];
  aspect: number[];
  twi: number[];
  lsi: number[];
  substrate: number[];
  foundationClass: string[];
  numPoints: number;
  computeTimeMs: number;
}

export interface ProceduralState {
  rawTerrain: RawTerrainData | null;
  computedData: ComputedGeomorphicData | null;
  isGenerating: boolean;
  generationProgress: number;
  generationError: string | null;
  sceneId: string | null;
  setRawTerrain: (raw: RawTerrainData | null) => void;
  setComputedData: (data: ComputedGeomorphicData | null) => void;
  setGenerating: (generating: boolean) => void;
  setGenerationProgress: (progress: number) => void;
  setGenerationError: (error: string | null) => void;
  setSceneId: (id: string | null) => void;
  clear: () => void;
}

export const useProceduralStore = create<ProceduralState>((set) => ({
  rawTerrain: null,
  computedData: null,
  isGenerating: false,
  generationProgress: 0,
  generationError: null,
  sceneId: null,

  setRawTerrain: (raw) => set({ rawTerrain: raw }),
  setComputedData: (data) => set({ computedData: data }),
  setGenerating: (generating) => set({ isGenerating: generating }),
  setGenerationProgress: (progress) => set({ generationProgress: progress }),
  setGenerationError: (error) => set({ generationError: error, isGenerating: false }),
  setSceneId: (id) => set({ sceneId: id }),

  clear: () => set({
    rawTerrain: null,
    computedData: null,
    isGenerating: false,
    generationProgress: 0,
    generationError: null,
    sceneId: null,
  }),
}));
